import type { HTMLAttributes, ReactNode } from "react";

import { cn, cv, type VariantProps } from "../utils";

const ncDataListClasses = {
  list: cv("", {
    variants: {
      variant: {
        vertical: "grid *:grid *:grid-cols-[1fr_2fr] gap-2.5",
        horizontal: "flex flex-wrap gap-x-6 gap-y-2 *:flex",
      },
    },
    defaultVariants: {
      variant: "vertical",
    },
  }),
  item: "items-baseline gap-1.5",
  itemValue: cv("font-bold", {
    variants: {
      variant: {
        default: "",
        ellipsis: "overflow-hidden text-ellipsis whitespace-nowrap",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }),
};

export interface NcDataListItemProps
  extends HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof ncDataListClasses.itemValue> {
  label: string | ReactNode;
}

const NcDataListItem = ({ label, variant, children, className, ...props }: NcDataListItemProps) => {
  return (
    <div data-nc="NcDataList.Item" className={cn(ncDataListClasses.item, className)} {...props}>
      <dt>{label}</dt>
      <dd className={ncDataListClasses.itemValue({ variant })}>{children}</dd>
    </div>
  );
};

export interface NcDataListProps
  extends HTMLAttributes<HTMLDListElement>,
    VariantProps<typeof ncDataListClasses.list> {
  children: ReactNode;
}

export const NcDataList = ({ children, variant, className, ...props }: NcDataListProps) => {
  return (
    <dl
      data-nc="NcDataList"
      className={cn(ncDataListClasses.list({ variant }), className)}
      {...props}
    >
      {children}
    </dl>
  );
};

NcDataList.Item = NcDataListItem;
